/* eslint-disable camelcase */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import './VMNManagement.css';
import {
  sess_post,
} from '../../../utils/HttpRequests';

const VMNAllotPremium = () => {
  const [detail, setDetail] = useState({
    phoneNumber: '', newVMN: '', category: '', price: '',
  });
  const [error, setError] = useState('');

  const onChange = (e) => {
    e.preventDefault();
    setDetail({ ...detail, [e.target.id]: e.target.value });
  };

  const allot = async () => {
    try {
      if (!detail.phoneNumber) {
        setError('PhoneNumber is required');
        return;
      }
      if (!detail.newVMN) {
        setError('VMN is required');
        return;
      }
      if (!detail.category) {
        setError('Select category');
        return;
      }
      if (!detail.price) {
        setError('Price is required');
        return;
      }
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      const params = {
        category: detail.category,
        price: Math.max(0, detail.price),
        phone_number: detail.phoneNumber,
        new_v_mobile_no: detail.newVMN,
      };
      await sess_post('admin/console/allot-premium-vip-number', sessionToken, params);
      setError('');
      setDetail({
        phoneNumber: '', newVMN: '', category: '', price: 0,
      });
    } catch (err) {
      setError(err?.response?.data?.error?.reason || err.message || 'something went wrong in update category price');
    }
  };

  return (
    <div style={{ textAlign: 'left', fontWeight: 'bolder' }}>
      <form className="form-horizontal">
        <div className="container">
          <div className="label">Allot Premium/VIP No</div>
          <div className="inputs-fl-2">
            <input className="form-control" type="number" placeholder="10 digit registered No" id="phoneNumber" value={detail.phoneNumber} onChange={onChange} />
            <span style={{ color: 'green' }}>**10 digit</span>
          </div>
          <div className="inputs-fl-1">
            <input className="form-control" type="number" placeholder="Enter new VMN" id="newVMN" value={detail.newVMN} onChange={onChange} />
            <span style={{ color: 'green' }}>**10 digit (91 is optional)</span>
          </div>
          <div className="inputs-fl-1">
            <select className="form-control" onChange={onChange} id="category" value={detail.category}>
              <option value="" selected="selected">Select VMN category</option>
              <option value="similar">Similar</option>
              <option value="premium">Premium</option>
              <option value="vip">VIP</option>
            </select>
          </div>
          <div className="inputs-fl-1">
            <input className="form-control" type="number" id="price" value={detail.price} placeholder="Enter Price" onChange={onChange} />
            <span style={{ color: 'green' }}>
              **Price in rupees
            </span>
          </div>
          <div className="inputs-fl-1">
            <Button variant="danger" disable={!detail.category || detail.phoneNumber || detail.newVMN || detail.price} onClick={allot}>allot</Button>
          </div>
          {error && (
          <div className="label" style={{ color: 'red' }}>
            {error}
          </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default VMNAllotPremium;
